import React from "react";
import moment from "moment";
import { Div, Image, Text, Icon } from "atomize";

import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

const BlogCardMobile = ({ content, ...rest }) => {
  return (
    <a href={`/blog/${content.node.slug}`} target="_blank">
      <Div
        p="2rem 0"
        border={{ b: "1px solid" }}
        borderColor="border"
        d="flex"
        justify="space-between"
        align="flex-start"
        textColor="white"
      >
        <Div p={{ r: "1.5rem" }}>
          <Text
            textSize="tiny"
            textWeight="700"
            m={{ b: "0.5rem" }}
            style={{ letterSpacing: "1.5px" }}
            textTransform="uppercase"
          >
            {content.node.label}
            {content.node.publishedAt &&
              ` | ${moment(content.node.publishedAt).format("MMMM Do YYYY")}`}
          </Text>
          <Text textSize="paragraph" textWeight="700">
            “{content.node.title}”
          </Text>
        </Div>
        <ImageLink link={content.node.thumbnail.description}>
          <Div
            h="5rem"
            w="5rem"
            minW="5rem"
            bgImg={content.node.thumbnail.file.url}
            bgSize="cover"
            bgPos="center"
            d="flex"
            align="center"
            justify="center"
          ></Div>
        </ImageLink>
      </Div>
    </a>
  );
};

export default BlogCardMobile;
